var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43012 1.9491C7.567 1.80255 7.76196 1.71094 7.97832 1.71094C8.19292 1.71094 8.38647 1.80107 8.52318 1.94554L11.9429 5.5443C12.2282 5.84457 12.2161 6.31929 11.9159 6.60462C11.6156 6.88995 11.1409 6.87784 10.8555 6.57757L8.72832 4.33898V10.8609C8.72832 11.2752 8.39253 11.6109 7.97832 11.6109C7.56411 11.6109 7.22832 11.2752 7.22832 10.8609V4.35584L5.14606 6.57422C4.86258 6.87624 4.38794 6.89126 4.08593 6.60778C3.78392 6.3243 3.7689 5.84966 4.05238 5.54765L7.43012 1.9491ZM2.19922 9.71094C2.61343 9.71094 2.94922 10.0467 2.94922 10.4609V12.0609C2.94922 12.7513 3.50886 13.3109 4.19922 13.3109H11.7992C12.4896 13.3109 13.0492 12.7513 13.0492 12.0609V10.4609C13.0492 10.0467 13.385 9.71094 13.7992 9.71094C14.2134 9.71094 14.5492 10.0467 14.5492 10.4609V12.0609C14.5492 13.5797 13.318 14.8109 11.7992 14.8109H4.19922C2.68044 14.8109 1.44922 13.5797 1.44922 12.0609V10.4609C1.44922 10.0467 1.78501 9.71094 2.19922 9.71094Z",
    fill: "#0061C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpTray);
export default __webpack_public_path__ + "static/media/arrow-up-tray.ac57623bf7dbba268035f7d8a7526ea4.svg";
export { ForwardRef as ReactComponent };